export default function Footer() {
  return (
    <footer className="max-h-[100px] bg-white">
      <div className="mx-auto flex justify-center px-4 py-3">
        <p className="text-center text-sm text-NBNA-primary font-lato">
          &copy; {new Date().getFullYear()} Nanaimo Business Networking Association . All rights reserved.
        </p>
      </div>
    </footer>
  );
}
